import WebSupport from '../views/webSupport/webSupport';

export default [
  {
    path: '/',
    name: '',
    component: WebSupport,
  },
  {
    path: '/creatework',
    name: 'creatework',
    component: WebSupport,
  },
  {
    path: '/mylist',
    name: 'mylist',
    component: WebSupport,
  },
  {
    path: '/mywork/:workId',
    name: 'mywork',
    component: WebSupport,
  },
  {
    path: '/account',
    name: 'accountrecovery',
    component: WebSupport,
  },
];
